import {User} from '@app/models/vcr-entity/user';
import {CurrentClass} from '@app/models/current-class';

export class InitRoom {
  token: string;
  roomName: string;
  cmsUrl: string;
  studentPortalUrl: string;
  newStudentPortalUrl: string;
  studentLateTime: number;
  currentClass: CurrentClass;
  isCurrentClassParticipant: boolean;
  isInDNDMode: boolean;
  participants: User[];
  stickers: string[];
}
